(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[177],{

/***/ 4783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work/[slug]",
      function () {
        return __webpack_require__(2836);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



var ImageWithTransition = function(param) {
    var src = param.src, layout = param.layout, sizes = param.sizes, _alt = param.alt, alt = _alt === void 0 ? "" : _alt, classes = param.classes, objectFit = param.objectFit, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var onLoadingComplete = function() {
        return setIsLoading(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        className: "".concat(classes, " transition-all duration-500 ").concat(isLoading ? "opacity-0" : "opacity-100"),
        src: src,
        layout: layout,
        onLoadingComplete: onLoadingComplete,
        objectFit: objectFit,
        priority: priority,
        quality: quality,
        loading: loading,
        alt: alt,
        sizes: sizes
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageWithTransition);


/***/ }),

/***/ 6980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ NewsCard; },
  "t": function() { return /* binding */ ProjectCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-fast-marquee/dist/index.js
var dist = __webpack_require__(7005);
// EXTERNAL MODULE: ./components/Elements/ImageWithTransition.js
var ImageWithTransition = __webpack_require__(2142);
// EXTERNAL MODULE: ./node_modules/bowser/es5.js
var es5 = __webpack_require__(1206);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
;// CONCATENATED MODULE: ./components/Elements/VideoLazy.js



function VideoLazy(param) {
    var videoDesktop = param.videoDesktop, videoMobile = param.videoMobile;
    var ref = (0,react.useState)(null), platform = ref[0], setPlatform = ref[1];
    (0,react.useEffect)(function() {
        var browser = es5_default().getParser(window.navigator.userAgent);
        setPlatform(browser.getPlatform().type);
    }, []);
    (0,react.useEffect)(function() {
        var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
        if ("IntersectionObserver" in window) {
            var lazyVideoObserver = new IntersectionObserver(function(entries) {
                entries.forEach(function(video) {
                    if (video.isIntersecting) {
                        for(var source in video.target.children){
                            var videoSource = video.target.children[source];
                            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                videoSource.src = videoSource.dataset.src;
                            }
                        }
                        video.target.load();
                        video.target.classList.remove("lazy");
                        lazyVideoObserver.unobserve(video.target);
                    }
                });
            });
            lazyVideos.forEach(function(lazyVideo) {
                lazyVideoObserver.observe(lazyVideo);
            });
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        preload: "metadata",
        className: "lazy object-center h-full w-full object-cover",
        autoPlay: true,
        muted: true,
        playsInline: true,
        loop: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
            "data-src": platform === "desktop" ? videoDesktop : videoMobile,
            type: "video/mp4"
        })
    });
}

;// CONCATENATED MODULE: ./components/GridCards/index.js






var ProjectCard = function(props) {
    var ref = (0,react.useState)(false), isShown = ref[0], setIsShown = ref[1];
    return props.outsideURL ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: props.outsideURL,
            className: "group",
            onMouseEnter: function() {
                return setIsShown(true);
            },
            onMouseLeave: function() {
                return setIsShown(false);
            },
            target: "_blank",
            rel: "noreferrer",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative image-container aspect-video",
                    children: [
                        props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                            videoDesktop: props.videoDesktop,
                            videoMobile: props.videoMobile
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                            src: props.imageUrl,
                            objectFit: "cover",
                            layout: "fill",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                    gradient: false,
                                    play: isShown,
                                    speed: 80,
                                    direction: props.index % 2 == 0 ? "left" : "right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-white uppercase",
                                        children: [
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-block mr-2 align-top fluid-type-medium",
                                                children: props.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "inline-block mr-2 align-top text-18",
                                                children: [
                                                    "view",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "relative -top-0.5 ml-1",
                                                        children: "↗"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between gap-x-[20px] mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props.title
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.client
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                            ]
                        }),
                        props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.year
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fluid-type-mini flex items-center ml-auto h-[28px] w-[56px] min-w-[56px] 768:h-[32px] 768:w-[70px] 768:min-w-[70px] whitespace-nowrap rounded-[50%] bg-black border-black border-[3px] text-white uppercase overflow-hidden mb-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "btn-ticker-inner-v3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-text": "News",
                                        children: "News"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            scroll: false,
            href: props.projectLink,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: "group",
                onMouseEnter: function() {
                    return setIsShown(true);
                },
                onMouseLeave: function() {
                    return setIsShown(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative image-container aspect-video",
                        children: [
                            props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                                videoDesktop: props.videoDesktop,
                                videoMobile: props.videoMobile
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                                src: props.imageUrl,
                                objectFit: "cover",
                                layout: "fill",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-0 left-0 w-full h-full transition-opacity duration-300 opacity-0 card-overlay ease-easeInOutQuint group-hover:opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-full overlay-bg bg-black/40"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                        gradient: false,
                                        play: isShown,
                                        speed: 80,
                                        direction: props.index % 2 == 0 ? "left" : "right",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-white uppercase",
                                            children: [
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block mr-2 align-top fluid-type-medium",
                                                    children: props.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-block mr-2 align-top text-18",
                                                    children: [
                                                        "view",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "relative -top-0.5 ml-1",
                                                            children: "↗"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-12 gap-0 mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-span-8 991:col-span-10",
                                children: [
                                    props.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: props.title
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    props.client ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: props.client
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            }),
                            props.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-span-4 991:col-span-2 text-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: props.year
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            })
        })
    });
};
var NewsCard = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "card ".concat(props.size == "Large" ? "1024:col-span-8 col-span-12" : "1024:col-span-4 col-span-12"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-container",
                children: props.videoDesktop && props.videoMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLazy, {
                    videoDesktop: props.videoDesktop,
                    videoMobile: props.videoMobile
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                    src: props.imageUrl,
                    layout: "fill",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-2 leading-6 uppercase project-info text-16 768:text-18 1280:text-22",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: props.title
                })
            })
        ]
    });
};


/***/ }),

/***/ 2836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/Elements/ImageWithTransition.js
var ImageWithTransition = __webpack_require__(2142);
// EXTERNAL MODULE: ./components/MetaTags/index.js
var MetaTags = __webpack_require__(8992);
// EXTERNAL MODULE: ./components/Elements/Container.js
var Container = __webpack_require__(4721);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./components/ProjectAssets/index.js



var TwoColumns = function(param) {
    var sources = param.sources;
    return sources.map(function(src, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image-container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                    src: src,
                    layout: "fill",
                    alt: "",
                    sizes: "50vw"
                })
            })
        }, key);
    });
};
var OneColumn = function(param) {
    var source = param.source;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "col-span-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "image-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                src: source,
                layout: "fill",
                alt: ""
            })
        })
    });
};
var TwoRows = function(param) {
    var sources = param.sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1 row-span-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                        src: sources[0],
                        layout: "fill",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                        sizes: "50vw",
                        objectFit: "cover",
                        src: sources[1],
                        layout: "fill",
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                        sizes: "50vw",
                        objectFit: "cover",
                        src: sources[2],
                        layout: "fill",
                        alt: ""
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.min.js
var plyr_min = __webpack_require__(1443);
var plyr_min_default = /*#__PURE__*/__webpack_require__.n(plyr_min);
// EXTERNAL MODULE: ./components/GridCards/index.js + 1 modules
var GridCards = __webpack_require__(6980);
// EXTERNAL MODULE: ./strapi/api.js + 4 modules
var api = __webpack_require__(1014);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
;// CONCATENATED MODULE: ./pages/work/[slug].js










var Slug = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useState)(false), hasControl = ref3[0], setHasControl = ref3[1];
    var ref4 = (0,react.useState)({
        id: ((ref1 = props === null || props === void 0 ? void 0 : (ref = props.content) === null || ref === void 0 ? void 0 : ref.cover_media[0]) === null || ref1 === void 0 ? void 0 : ref1.video_id) ? props.content.cover_media[0].video_id : ""
    }), video = ref4[0], setVideo = ref4[1];
    var getIdFromUrl = function(url) {
        var splittedUrl = url.split("/");
        var id = splittedUrl.filter(function(key) {
            return key && !isNaN(key);
        })[0];
        return id;
    };
    (0,react.useEffect)(function() {
        var controls = document.querySelector(".vp-player-ui-overlays");
        if (!hasControl) {}
    }, [
        hasControl
    ]);
    (0,react.useEffect)(function() {
        var videos = props.content.gallery.filter(function(item) {
            return item.__component === "general.video-gallery";
        });
        var players = Array.from(document.querySelectorAll(".plyr-players")).map(function(player) {
            var isHero = player.dataset.isHero === "true";
            var hasAutoplay = player.dataset.autoplay === "true";
            var newPlyr = new (plyr_min_default())(player, {
                title: "".concat(props.content.title, " video"),
                storage: {
                    enabled: false
                },
                controls: [
                    "play-large",
                    "progress",
                    "mute",
                    "volume",
                    "fullscreen"
                ],
                clickToPlay: true,
                autopause: true,
                autoplay: hasAutoplay ? true : false,
                muted: false,
                loop: {
                    active: false
                },
                vimeo: {
                    byline: false,
                    portrait: false,
                    title: false,
                    speed: false,
                    transparent: false,
                    controls: true
                },
                ratio: null,
                fullscreen: {
                    iosNative: true
                }
            });
            return newPlyr;
        });
        return function() {
            players.map(function(player) {
            // player.destroy()
            });
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                title: props.content && props.content.title ? props.content.title + "" : "",
                description: props.content.meta_info && props.content.meta_info.meta_description ? props.content.meta_info.meta_description : props.content.title,
                image: props.content.meta_info && props.content.og_image ? api/* default.getNextImage */.Z.getNextImage(props.content.meta_info.og_image) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "offscreen-title",
                        children: props.content.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-black 768:mb-8",
                        children: (props === null || props === void 0 ? void 0 : (ref2 = props.content) === null || ref2 === void 0 ? void 0 : ref2.cover_media[0]) && props.content.cover_media[0].image ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "image-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWithTransition/* default */.Z, {
                                src: api/* default.getNextImage */.Z.getNextImage(props.content.cover_media[0].image),
                                layout: "fill",
                                objectFit: "cover",
                                alt: ""
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "hero-player",
                            "data-autoplay": "true",
                            "data-is-hero": "true",
                            className: "plyr-players hero",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                src: "https://player.vimeo.com/video/".concat(getIdFromUrl(video.id)),
                                allowtransparency: "true",
                                allow: "autoplay"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                id: "project-details",
                                className: "grid col-span-6 gap-3 991:grid-cols-12 991:gap-5 gap-y-0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 row-span-2 mb-5 991:col-span-8",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-20 991:text-52 leading-[1.15] content-with-glyphs",
                                            children: (0,html_react_parser/* default */.ZP)(props.content.content)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-12 row-start-1 mt-4 991:col-span-3 1366:col-span-2 991:col-start-10 1366:col-start-11 h-max",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "mb-5 leading-none uppercase text-18 991:text-30 991:mb-4",
                                            children: props.content.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-12 leading-tight uppercase 991:col-span-3 1366:col-span-2 991:col-start-10 1366:col-start-11 text-16 768:text-18 1280:text-22",
                                        children: [
                                            props.content.details ? props.content.details.map(function(detail, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col mb-4",
                                                    children: [
                                                        detail.title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: detail.title
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                        detail.value ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: detail.value
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                    ]
                                                }, i);
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            props.content.year ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: props.content.year
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                        ]
                                    })
                                ]
                            }),
                            props.content.gallery ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                id: "project-assets-grid",
                                className: "grid grid-cols-2 gap-1 mt-8 640:gap-5",
                                children: props.content.gallery.map(function(item, index) {
                                    if (item.__component == "general.50-50-images") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumns, {
                                            sources: [
                                                api/* default.getNextImage */.Z.getNextImage(item.left_image),
                                                api/* default.getNextImage */.Z.getNextImage(item.right_image), 
                                            ]
                                        }, index);
                                    }
                                    if (item.__component == "general.full-width-image") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(OneColumn, {
                                            source: api/* default.getNextImage */.Z.getNextImage(item.full_image)
                                        }, index);
                                    }
                                    if (item.__component == "general.grid-1-vertical-image-2-horizontal-images") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoRows, {
                                            sources: [
                                                api/* default.getNextImage */.Z.getNextImage(item.vertical_image),
                                                api/* default.getNextImage */.Z.getNextImage(item.first_right_image),
                                                api/* default.getNextImage */.Z.getNextImage(item.second_right_image), 
                                            ]
                                        }, index);
                                    }
                                    if (item.__component == "general.video-gallery") {
                                        return item.autoplay ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                preload: "metadata",
                                                className: "w-full",
                                                autoPlay: true,
                                                muted: true,
                                                playsInline: true,
                                                loop: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                                    src: item.vimeo_url,
                                                    type: "video/mp4"
                                                })
                                            })
                                        }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-span-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "plyr-players",
                                                "data-autoplay": "false",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                    className: "w-full",
                                                    src: "https://player.vimeo.com/video/".concat(getIdFromUrl(item.vimeo_url)),
                                                    allowtransparency: "true",
                                                    allow: "autoplay"
                                                })
                                            })
                                        }, index);
                                    }
                                    if (item.__component == "general.video-50-50") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                item.left_video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-1",
                                                    children: item.autoplay_left ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                        autoPlay: true,
                                                        muted: true,
                                                        playsInline: true,
                                                        loop: true,
                                                        src: item.left_video
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "plyr-players",
                                                        "data-autoplay": "false",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                            className: "w-full",
                                                            src: "https://player.vimeo.com/video/".concat(getIdFromUrl(item.left_video)),
                                                            allowtransparency: "true",
                                                            allow: "autoplay"
                                                        })
                                                    })
                                                }),
                                                item.right_video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-span-1",
                                                    children: item.autoplay_right ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                                        autoPlay: true,
                                                        muted: true,
                                                        playsInline: true,
                                                        loop: true,
                                                        src: item.right_video
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "plyr-players",
                                                        "data-autoplay": "false",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                            className: "w-full",
                                                            src: "https://player.vimeo.com/video/".concat(getIdFromUrl(item.right_video)),
                                                            allowtransparency: "true",
                                                            allow: "autoplay"
                                                        })
                                                    })
                                                })
                                            ]
                                        });
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            props.otherWork.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "mt-8 mb-2 768:mb-11",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "font-thin leading-none uppercase fluid-type",
                                        children: "more work"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "grid grid-cols-1 mt-6 768:grid-cols-12 gap-x-5 gap-y-2 768:gap-5",
                                        children: props.otherWork.map(function(project, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(GridCards/* ProjectCard */.t, {
                                                projectLink: "/work/" + project.attributes.slug,
                                                imageUrl: api/* default.getNextImage */.Z.getNextImage(project.attributes.thumbnail),
                                                title: project.attributes.title,
                                                client: project.attributes.client,
                                                year: project.attributes.year
                                            }, index);
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (Slug);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,84,443,774,888,179], function() { return __webpack_exec__(4783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);